export default "__VITE_ASSET__DEcSuKVj__"